import React from 'react';

export const LivestreamDark: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='18' height='18' fill='none' viewBox='0 0 18 18'>
    <path fill='#000615' fillRule='evenodd' d='M9 1a8 8 0 100 16V1z' clipRule='evenodd'></path>
    <path fill='#0D47D9' fillRule='evenodd' d='M9 17A8 8 0 109 1v16z' clipRule='evenodd'></path>
    <path
      fill='#0E1420'
      d='M9 16a7 7 0 01-7-7H0a9 9 0 009 9v-2zm7-7a7 7 0 01-7 7v2a9 9 0 009-9h-2zM9 2a7 7 0 017 7h2a9 9 0 00-9-9v2zm0-2a9 9 0 00-9 9h2a7 7 0 017-7V0z'
    ></path>
  </svg>
);
